// ConfirmProvider.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import { Modal,  ModalBody, ModalFooter, Button } from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";

const ConfirmContext = createContext(null);

// Clases del sistema por color (regla de botones genericos).
const BUTTON_CLASSES = {
  primary: "btn-color-primary",
  success: "btn-color-success",
  secondary: "btn-color-gray",
  danger: "btn-color-danger",
};

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm debe usarse dentro de <ConfirmProvider>");
  return ctx;
}

export function ConfirmProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState({});
  const [resolver, setResolver] = useState(null);

  const confirm = useCallback((options = {}) => {
    return new Promise((resolve) => {
      setOpts(options);
      setResolver(() => resolve);
      setOpen(true);
    });
  }, []);

  const resolveAndClose = (value) => {
    setOpen(false);
    if (resolver) resolver(value);
    setResolver(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Modal
        isOpen={open}
        toggle={() => resolveAndClose(false)}
        size={opts.size}                // "sm" | "lg" | "xl"
        backdrop={opts.backdrop ?? true} // true | false | "static"
        keyboard={opts.keyboard ?? true}
      >
        {opts.title && (
          <ModalHeader
            toggle={() => resolveAndClose(false)}
            iconClass={opts.icon ?? "fa-question-circle"}
            iconVariant={opts.iconVariant}
            description={opts.title}
            subtitle={opts.subtitle ?? "Revise la información y confirme para continuar."}
          />
        )}
        <ModalBody>{opts.message}</ModalBody>
        <ModalFooter>
          <Button
            color={opts.confirmColor ?? "success"}
            className={BUTTON_CLASSES[opts.confirmColor ?? "success"]}
            onClick={() => resolveAndClose(true)}
          >
            <i className={`fa ${opts.confirmIcon ?? "fa-check"}`} aria-hidden="true"></i>
            {` ${opts.confirmText ?? "Confirmar"}`}
          </Button>
          <Button
            color={opts.cancelColor ?? "danger"}
            className={BUTTON_CLASSES[opts.cancelColor ?? "danger"]}
            onClick={() => resolveAndClose(false)}
          >
            <i className={`fa ${opts.cancelIcon ?? "fa-times"}`} aria-hidden="true"></i>
            {` ${opts.cancelText ?? "Cancelar"}`}
          </Button>
        </ModalFooter>
      </Modal>
    </ConfirmContext.Provider>
  );
}
